/* global zxcvbn */

import loadJavascript from '../../shared/utils/loadJavascript';

const ZXCVBN_SRC = 'https://cdnjs.cloudflare.com/ajax/libs/zxcvbn/4.4.2/zxcvbn.js';

function loadZxcvbn() {
  if (typeof zxcvbn !== 'undefined') {
    return Promise.resolve(zxcvbn);
  }
  return loadJavascript(ZXCVBN_SRC).then(() => zxcvbn);
}

export default function checkPasswordStrength(password) {
  return loadZxcvbn().then((zxcvbn) => zxcvbn(password));
}
